import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { useMutation } from "@apollo/client";

import { Button, FormGroup, showSnackbar } from "@cofano/cck";
import { Tooltip } from "@mui/material";

import { FormDialog } from "components/dialogs/Dialogs";
import FormField from "components/cck/FormField";

import RelationSelect from "view/relations/components/selects/RelationSelect";

import { CargoFromQuery } from "./BulkPlanningTable";

import { Language } from "utils";

import { BatchUpdateCargosDocument } from "__generated__/view/containers/graphql/mutations.generated";
import { RelationType } from "__generated__/graphql";
import { Relation } from "types/index";

type CargoRelationChangeForm = {
	supplier?: Pick<Relation, "id" | "name">
}

const CargoRelationChange = ({
	selection = [],
	refetch,
}: {
	selection: CargoFromQuery[],
	refetch: () => void
}) => {

	const [ open, setOpen ] = useState(false);

	const { handleSubmit, control, reset, formState } = useForm<CargoRelationChangeForm>({
		defaultValues: {
			supplier: undefined,
		},
	});

	const handleOnClose = () => {
		setOpen(false);
		reset();
	};

	const [ updateCargos, { loading } ] = useMutation(BatchUpdateCargosDocument);

	const save = (data: CargoRelationChangeForm) => {

		updateCargos({
			variables: {
				input: {
					ids: selection.map(c => c.id),
					supplierId: data.supplier?.id,
				},
			},
		}).then(() => {
			handleOnClose();
			showSnackbar(intl.formatMessage({ id: "SUCCESSFUL_SAVED" }), { variant: "success" });
			refetch();
		});
	};

	return (
		<div>
			<Tooltip title={intl.formatMessage({ id: "BULK_CARGO_EDIT_INVALID_TOOLTIP" })} placement="left">
				<span>
					<Button
						onClick={() => setOpen(!open)}
						variant="outlined"
						size="small"
						disabled={!!selection.find(c => c.actions.length > 2) || selection.length == 0}>
						{intl.formatMessage({ id: "CHANGE_RELATIONS_FOR_X_CARGOS" }).replace("_X_", selection.length.toString())}
					</Button>
				</span>
			</Tooltip>

			<FormDialog
				open={open}
				onClose={handleOnClose}
				title={intl.formatMessage({ id: "EDIT_SELECTED_CARGOS" })}
				form='cargoRelationChangeForm'
				loading={loading}>
				<React.Fragment>
					<form onSubmit={(event) => void handleSubmit(save)(event)} id="cargoRelationChangeForm">
						<FormGroup
							label={Language("SUPPLIER")}
							labelPlacement="left-center"
							overflow="hidden"
							required>
							<FormField errors={formState.errors} name={"supplier"}>
								<Controller
									name="supplier"
									control={control}
									rules={{ required: true }}
									render={({ field }) => <RelationSelect { ...field } types={[ RelationType.Supplier ]} />} />
							</FormField>
						</FormGroup>
					</form>
				</React.Fragment>
			</FormDialog>
		</div>
	);
};

export default CargoRelationChange;
